import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { putAlertasPlanoDeAcao } from './services'
import { TRequestPlanoDeAcao } from './types'
import { toast } from "sonner";

const initialState: any = {
  status: "",
  data: ""
}

export const actionPutAlertasPlanoDeAcao = createAsyncThunk<any, TRequestPlanoDeAcao>(
  "ACTION_PUT_ALERTA_PLANO_DE_ACAO",
    async (data) => {
    return putAlertasPlanoDeAcao(data)
  }
)


const slicePutAlertasPlanoDeAcao = createSlice({
  name: "PUT_ALERTA_PLANO_DE_ACAO",
  initialState,
  reducers: {
    actionResetPutAlertasPlanoDeAcao: (state) => {
      state.status = ""
      state.data = ""
    }
  },
  extraReducers: {
    [`${actionPutAlertasPlanoDeAcao.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionPutAlertasPlanoDeAcao.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
      toast.success("Inserido com sucesso!");
    },
    [`${actionPutAlertasPlanoDeAcao.rejected}`]: (state) => {
      state.status = "error"
      toast.error("Erro ao inserir dados. Tente novamente.")
    },
  }
})

export default slicePutAlertasPlanoDeAcao.reducer
export const { actionResetPutAlertasPlanoDeAcao } =
  slicePutAlertasPlanoDeAcao.actions;